import { render, staticRenderFns } from "./Deduplicate.vue?vue&type=template&id=28bcf37c&scoped=true"
import script from "./Deduplicate.vue?vue&type=script&lang=js"
export * from "./Deduplicate.vue?vue&type=script&lang=js"
import style0 from "./Deduplicate.vue?vue&type=style&index=0&id=28bcf37c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bcf37c",
  null
  
)

export default component.exports